export default __webpack_public_path__ + "static/media/mario7.c2f553e9.jpg";